<template>
  <button 
    @click="$emit('click')"
    :class="[
      isMobile ? 
        'fixed bottom-20 right-6 rounded-full w-14 h-14 bg-emerald-500 shadow-md z-50 flex items-center justify-center' : 
        'rounded-xl bg-emerald-500 px-8 py-3 font-semibold text-sm'
    ]"
  >
    <!-- Desktop version -->
    <span v-if="!isMobile" class="flex items-center gap-2">
      <PlusIcon class="h-5 w-5 hidden 2xl:block" />
      <slot />
    </span>
    
    <!-- Mobile version (FAB) -->
    <PlusIcon v-else class="h-7 w-7" />
  </button>
</template>

<script setup lang="ts">
import { PlusIcon } from 'lucide-vue-next';
import { ref, onMounted, onUnmounted } from 'vue';

// Responsive detection
const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>